import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'var(--color-colorPrimary-main)',

    '& h1': {
      marginBottom: 0,
      fontSize: '2rem',
      fontWeight: 500,
    },

    '& h4': {
      marginTop: 8,
      fontSize: '1.5rem',
      fontWeight: 500,
    },
  },
}));

const NotFound = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <h1>404</h1>
      <h4>Page not found</h4>
    </div>
  );
};

export default NotFound;
